import styled from '@emotion/styled';

export const Root = styled('iframe')(({ theme }) => ({
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    minHeight: '100%',
    border: 'none',
    backgroundColor: theme.palette.background.paper,
    overflow: 'none'
}));

export const FullScreenButton = styled('div')(() => ({
    zIndex: '11',
    fontSize: '25px',
    right: '10px',
    bottom: '10px',
    cursor: 'pointer',
    background: 'black',
    padding: '5px',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    opacity: 0.5,
    transition: '0.5s ease',
    '&:hover': {
        opacity: 1,
    },
}));

export const FullScreenNotify = styled('div')(() => ({
    zIndex: '12',
    background: 'rgb(0,0,0)',
    color: 'white',
    left: '50%',
    transform: 'translate(-50%, 0)',
    position: 'absolute',
    top: '10px',
    padding: '10px 15px',
    borderRadius: '10px',
    transition: '0.5s ease'
}));